// src/pages/impersonate/impersonate.tsx

import React, { FC, useEffect, useState } from 'react'
import { BaseLayout, Loader, Module, ModuleHeader } from 'components/'

import OktaAuth from '@okta/okta-auth-js'

import { oidcImpersonateGatewayConfig } from 'config/'

const ImpersonateGateway: FC = () => {
  //Note: the variable is confusingly named. It actually represents the main Okta authentication
  //Okta Org.  The application is called "Impersonate Gateway" on the main org.
  const authClient = new OktaAuth(oidcImpersonateGatewayConfig)

  authClient.token?.getWithRedirect({
    responseType: 'id_token',
  })

  return (
    <BaseLayout>
      <Loader visible={true} />
      <Module>
        <ModuleHeader title="Authenticating" children={undefined} />
      </Module>
    </BaseLayout>
  )
}

export default ImpersonateGateway
